import { handleActions } from 'redux-actions';

import {
  LOAD_BENTO_CART_REQUEST,
  LOAD_BENTO_CART_SUCCESS,
  LOAD_BENTO_CART_FAILURE,
  ADD_GIFT_CERTIFICATE_REQUEST,
  ADD_GIFT_CERTIFICATE_SUCCESS,
  ADD_GIFT_CERTIFICATE_FAILURE,
  DELETE_GIFT_CERTIFICATE_REQUEST,
  DELETE_GIFT_CERTIFICATE_SUCCESS,
  DELETE_GIFT_CERTIFICATE_FAILURE,
  GET_GIFT_CERTIFICATE_REQUEST,
  GET_GIFT_CERTIFICATE_SUCCESS,
  GET_GIFT_CERTIFICATE_FAILURE,
  BENTO_DELETE_BASKET_ITEMS_REQUEST,
  BENTO_DELETE_BASKET_ITEMS_SUCCESS,
  BENTO_DELETE_BASKET_ITEMS_FAILURE,
  COMPLETE_BENTO_CART_ORDER_REQUEST,
  COMPLETE_BENTO_CART_ORDER_SUCCESS,
  COMPLETE_BENTO_CART_ORDER_FAILURE,
  SUBMIT_BENTO_CART_ORDER_REQUEST,
  SUBMIT_BENTO_CART_ORDER_SUCCESS,
  SUBMIT_BENTO_CART_ORDER_FAILURE,
  UPDATE_BENTO_CART_WITH_ADDRESS_REQUEST,
  UPDATE_BENTO_CART_WITH_ADDRESS_SUCCESS,
  UPDATE_BENTO_CART_WITH_ADDRESS_FAILURE,
  UPDATE_BENTO_CART_WITH_PAYMENT_REQUEST,
  UPDATE_BENTO_CART_WITH_PAYMENT_SUCCESS,
  UPDATE_BENTO_CART_WITH_PAYMENT_FAILURE,
  GIFT_CARD_BALANCE_SUCCESS,
  GIFT_CARD_BALANCE_FAILURE,
  GIFT_CARD_BALANCE_REQUEST,
} from '../actions/giftcard';

export const defaultState = {
  loading: false,
};

export const updateStateFromPayload = (state, action) => {
  const { fetchedDate } = action.meta || {};

  if (!fetchedDate) {
    throw new Error('Fetched Date empty.');
  }

  return {
    ...defaultState,
    ...state,
    ...action.payload,
  };
};

const enableLoader = state => ({
  ...state,
  loading: true,
});

const disableLoader = state => ({
  ...state,
  loading: false,
});

export default handleActions(
  {
    [LOAD_BENTO_CART_REQUEST]: enableLoader,
    [LOAD_BENTO_CART_SUCCESS]: updateStateFromPayload,
    [LOAD_BENTO_CART_FAILURE]: disableLoader,

    [ADD_GIFT_CERTIFICATE_REQUEST]: enableLoader,
    [ADD_GIFT_CERTIFICATE_SUCCESS]: updateStateFromPayload,
    [ADD_GIFT_CERTIFICATE_FAILURE]: disableLoader,

    [DELETE_GIFT_CERTIFICATE_REQUEST]: enableLoader,
    [DELETE_GIFT_CERTIFICATE_SUCCESS]: updateStateFromPayload,
    [DELETE_GIFT_CERTIFICATE_FAILURE]: disableLoader,

    [GET_GIFT_CERTIFICATE_REQUEST]: enableLoader,
    [GET_GIFT_CERTIFICATE_SUCCESS]: (state, action) => {
      const { fetchedDate } = action.meta || {};

      if (!fetchedDate) {
        throw new Error('Fetched Date empty.');
      }

      return {
        ...defaultState,
        ...state,
        currentGiftCard: action.payload,
      };
    },
    [GET_GIFT_CERTIFICATE_FAILURE]: disableLoader,

    [BENTO_DELETE_BASKET_ITEMS_REQUEST]: enableLoader,
    [BENTO_DELETE_BASKET_ITEMS_SUCCESS]: updateStateFromPayload,
    [BENTO_DELETE_BASKET_ITEMS_FAILURE]: disableLoader,

    [COMPLETE_BENTO_CART_ORDER_REQUEST]: enableLoader,
    [COMPLETE_BENTO_CART_ORDER_SUCCESS]: updateStateFromPayload,
    [COMPLETE_BENTO_CART_ORDER_FAILURE]: disableLoader,

    [SUBMIT_BENTO_CART_ORDER_REQUEST]: enableLoader,
    [SUBMIT_BENTO_CART_ORDER_SUCCESS]: (state, action) => {
      const { fetchedDate } = action.meta || {};

      if (!fetchedDate) {
        throw new Error('Fetched Date empty.');
      }

      return {
        ...defaultState,
        ...state,
        order: action.payload,
      };
    },
    [SUBMIT_BENTO_CART_ORDER_FAILURE]: disableLoader,

    [UPDATE_BENTO_CART_WITH_ADDRESS_REQUEST]: enableLoader,
    [UPDATE_BENTO_CART_WITH_ADDRESS_SUCCESS]: updateStateFromPayload,
    [UPDATE_BENTO_CART_WITH_ADDRESS_FAILURE]: disableLoader,

    [UPDATE_BENTO_CART_WITH_PAYMENT_REQUEST]: enableLoader,
    [UPDATE_BENTO_CART_WITH_PAYMENT_SUCCESS]: updateStateFromPayload,
    [UPDATE_BENTO_CART_WITH_PAYMENT_FAILURE]: disableLoader,

    [GIFT_CARD_BALANCE_REQUEST]: enableLoader,
    [GIFT_CARD_BALANCE_SUCCESS]: updateStateFromPayload,
    [GIFT_CARD_BALANCE_FAILURE]: disableLoader,
  },
  defaultState
);
